import { useEffect } from 'react';

const AD_CLIENT = 'ca-pub-1312037524520514';

/**
 * AdBanner — Google AdSense display unit
 *
 * Props:
 *   slot      — Ad unit slot ID from AdSense dashboard (required for manual units)
 *   format    — 'auto' | 'fluid' | 'rectangle' | 'vertical' | 'horizontal'
 *   className — extra wrapper classes
 *
 * Usage:
 *   <AdBanner slot="1234567890" />
 *   <AdBanner slot="1234567890" format="horizontal" />
 */
export default function AdBanner({ slot, format = 'auto', className = '' }) {
  useEffect(() => {
    if (!slot || slot.startsWith('SLOT_ID')) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      // AdSense not loaded yet (dev mode or blocked by ad blocker)
    }
  }, [slot]);

  // Nezobrazuj nič pokiaľ nemáme reálne slot ID od AdSense
  if (!slot || slot.startsWith('SLOT_ID')) return null;

  return (
    <div className={`overflow-hidden ${className}`}>
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client={AD_CLIENT}
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive="true"
      />
    </div>
  );
}
